import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";
import { MapPlugin } from "@photo-sphere-viewer/map-plugin";
import '@photo-sphere-viewer/map-plugin/index.css';     // for MapPlugin
import "@photo-sphere-viewer/markers-plugin/index.css";
import "@photo-sphere-viewer/virtual-tour-plugin/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";
import { useRef, useState } from "react";
import { renderToStaticMarkup } from 'react-dom/server';
import CustomPanelContent from "./Component/CustomPanelContent";
import CustomMarker from "./Component/CustomMarker";
import data from "./data";
import { AutorotatePlugin } from "@photo-sphere-viewer/autorotate-plugin";

function TheResidenceViewer () {

  const [currentPanorama, setCurrentPanorama] = useState('assets/HotelMerlynn_360_4k/A4_Tripodless.jpg');
  const currentPanoramaId = useRef();
	const pSRef = useRef();
  const pSRefCore = useRef();

  const [currentScene, setCurrentScene] = useState(0);
  
  let markersPlugin = null;

  const points = [
    { yaw: 0.1029, pitch: 0.3158, name: 'Mountain Peak' },
    { yaw: 0.8532, pitch: -0.1646, name: 'Valley View' },
    { yaw: 2.7755, pitch: 0.7840, name: 'Forest Trail' },
    { yaw: 3.3742, pitch: 0.4757, name: 'Rock Formation' },
    { yaw: 4.6591, pitch: 0.6579, name: 'Alpine Lake' },
    { yaw: 5.7976, pitch: -0.0401, name: 'Distant Hills' },
  ];

  const renderPanelString = (data) => {
    return data.map(d =>
      renderToStaticMarkup(
        <CustomPanelContent
          id={d.id}
          url={d.url}
          file={d.file}
          img={d.img}
          longText={d.longText}
        />
      )
    )
  }

  const renderMarkerString = (data) => {
    return data.map(d =>
      renderToStaticMarkup(
        <CustomMarker
          id={d.id}
          icon={d.icon}
          img={d.img}
          name={d.name}
          type={d.type}
        />
      )
    )
  }
  
  const infoMarkerStringArr = renderMarkerString(data.infoMarkersData)
  const roomMarkerStringArr = renderMarkerString(data.roomMarkersData)
  const panelContentStringArr = renderPanelString(data.panelContentsData)

  const togglePanel = (id, panelContent) => {
    if (pSRefCore.current.panel.isVisible(id)) {
      pSRefCore.current.panel.hide();
    } else {
      pSRefCore.current.panel.show({
        id: id,
        width: '25%',
        content: panelContent,
      });
    }
  }

  const handleReady = (instance) => {
    pSRefCore.current = instance;
    const viewer = pSRef.current

		// initialize plugins 
		markersPlugin = instance.getPlugin(MarkersPlugin);
    const galleryPlugin = instance.getPlugin(GalleryPlugin);
    const mapPlugin = instance.getPlugin(MapPlugin);
    const autorotatePlugin = instance.getPlugin(AutorotatePlugin);

    if (!markersPlugin) return;

    // map plugin event, select hotspot
    mapPlugin.addEventListener('select-hotspot', ({ hotspotId }) => {
      let id = hotspotId + "-marker"

      let roomMap = data.roomMarkerMapData.find(item => item.id === id)

      currentPanoramaId.current = id
      setCurrentPanorama(roomMap.panorama)
      viewer.setPanorama(roomMap.panorama)
    });

    galleryPlugin.setItems(data.galleryData)

    // core event, panorama load
    pSRefCore.current.addEventListener('panorama-load', (panorama) => {
      mapPlugin.close()

      let lastCamPosition = viewer.getPosition();

      let roomMap = data.roomMarkerMapData.find(item => item.panorama == panorama.panorama)

      let hotspot = roomMap.id.replace("-marker", "");
      let newHotspotCenter = data.mapData[0].hotspots.find(item => item.id === hotspot)
      mapPlugin.setOptions({
        center: {
          x: newHotspotCenter.x,
          y: newHotspotCenter.y
        }
      })

      markersPlugin.clearMarkers()
      let markers = roomMap.markers.map(item => {
        let pairData = null
        let pairArr = null 
        if(item.data.type == "info"){
          pairData = data.infoMarkersData
          pairArr = infoMarkerStringArr
        }
        else if (item.data.type == "room"){
          pairData = data.roomMarkersData
          pairArr = roomMarkerStringArr
        }
        let pairIndex = pairData.findIndex(pair => pair.id == item.html)
        return {
          ...item,
          html: pairArr[pairIndex] 
        }
      })
      markers.forEach(marker => markersPlugin.addMarker(marker));

      
      let roomMapIndex = data.roomMarkerMapData.findIndex(item => item.panorama == panorama.panorama)
      let keypoints = [
        lastCamPosition,
        data.autorotatePointData[roomMapIndex]
      ];

      goToKeypoint(roomMapIndex)

      // console.log(keypoints)
      // autorotatePlugin.setKeypoints(keypoints)
      // autorotatePlugin.start();
      // console.log(data.autorotatePointData);
      // console.log(data);
      // console.log(autorotatePlugin);

    })

    pSRefCore.current.addEventListener('autorotate', (e) => {
      console.log('Autorotate event:', e);
      const currentIndex = autorotatePlugin.getCurrentIndex();
      console.log('Now at keypoint:', currentIndex);
    });

    // markers plugin
    markersPlugin.addEventListener("select-marker", (e) => {
      const id = e.marker.config.id
      const type = e.marker.config.data.type

      if (type == "info") {
        // cari di panelContent.marker yg sama dg id
        // id -> dining-area-info
        // panelContent.marker -> dining-area-info-marker
        if(infoMarkerStringArr.find(item => item.id === data.infoMarkersData.id)) {
          let panelContentIdx = data.panelContentsData.findIndex(item => item.marker === id)
          togglePanel(id, panelContentStringArr[panelContentIdx]);
        }
      }

      if (type == "room") {
        let roomMap = data.roomMarkerMapData.find(item => item.id === id)
        currentPanoramaId.current = id
        setCurrentPanorama(roomMap.panorama)
        viewer.setPanorama(roomMap.panorama)
      }
    });

  
  };

  const goToKeypoint = (index) => {
    if (!pSRef.current || index < 0 || index >= data.autorotatePointData.length) return;
    
    const viewer = pSRef.current;
    const targetPoint = data.autorotatePointData[index];
    
    setCurrentScene(index);
    
    // Animate to the target keypoint smoothly
    viewer.animate({
      yaw: targetPoint.yaw,
      pitch: targetPoint.pitch,
      speed: '20rpm', // Animation speed
      easing: 'inOutQuad', // Smooth easing
    })
    // .catch(() => {
    //   // Fallback: direct position change if animate fails
    //   viewer.rotate({
    //     yaw: targetPoint.yaw,
    //     pitch: targetPoint.pitch,
    //   });
    // });
  };

  const markersInit = data.roomMarkerMapData[0].markers.map(item => {
    let pairData = null
    let pairArr = null 
    if(item.data.type == "info"){
      pairData = data.infoMarkersData
      pairArr = infoMarkerStringArr
    }
    else if (item.data.type == "room"){
      pairData = data.roomMarkersData
      pairArr = roomMarkerStringArr
    }
    
    let pairIndex = pairData.findIndex(pair => pair.id == item.html)

    return {
      ...item,
      html: pairArr[pairIndex] 
    }
  })



	// declare plugins
  const plugins = [
    [
			MarkersPlugin, 
			{
        markers: markersInit 
			}
		],
    [
      GalleryPlugin,
    ],
    [
      MapPlugin,
      data.mapData[0]
    ],
    [
      AutorotatePlugin,
      {
        autostartDelay: null, // Disable auto start
        autorotateSpeed: '2rpm',
        // keypoints: data.autorotatePointData.map((pt, i) => ({
        //   position: pt,
        //   pause: 2000, // Pause 2 seconds at each point
        //   tooltip: pt.yaw,
        // })),
      }
    ]
  ];


  return (
    <div className="App" id={"container-the-residence-360"}>
      <ReactPhotoSphereViewer
        ref={pSRef}
        loadingImg= {"assets/HotelMerlynn_Map/logo_MPH_Original_backgroundWhite.png"}
        name=""
        defaultYaw={"0deg"}
        navbar={[
          "zoom",
          "move",
          "gallery",
          // "download",
          // "caption",
          "fullscreen",
        ]}
        height={"100vh"}
        width={"100%"}
        hideNavbarButton={false}
        onReady={(instance) => {
          handleReady(instance)
        }}
        defaultZoomLvl="0"
        plugins={plugins}
        container={"container-the-residence-360"}
        src={currentPanorama}
      ></ReactPhotoSphereViewer>
    </div>
  );
}

export default TheResidenceViewer;